/* eslint-disable camelcase */
import React from "react";

import Image from "next/image";
import Link from "next/link";
import { makeStyles } from "@material-ui/core/styles";
import { Modal, Grid, Box, Button, Typography } from "@material-ui/core";

import orgIma from "../../../../../public/assets/images/op/orgmem.svg";
import realIma from "../../../../../public/assets/images/op/realmem.svg";
import AgapeIcon from "../../../../common/icons/AgapeIcon";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 600,
    borderRadius: "15px",
    top: `${35}%`,
    left: `${35}%`,
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      top: `${10}%`,
      left: `${0}%`,
      maxWidth: "100%",
    },
  },
  top: {
    height: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    position: "relative",
  },
  title: {
    fontFamily: "Vazir-Bold",
    fontSize: "1.5rem",
  },
  bot: {
    backgroundColor: "#f8f9fe",
    padding: "3rem 4rem !important",
    [theme.breakpoints.down("md")]: {
      padding: "3rem 2rem !important",
    },
  },
  btnBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",

    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
      justifyContent: "space-between",
    },
  },
  btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "#fff",
    width: "250px",
    height: "200px !important",
    borderRadius: "1rem",
    [theme.breakpoints.down("md")]: {
      maxWidth: "150px",
      maxHeight: "150px",

      justifyContent: "space-between",
    },
  },
  icontext: {
    color: "#18c5bf",
    fontFamily: "Vazir-Bold",
    fontSize: "1.3rem",
  },
  closeIcon: {
    position: "absolute",
    left: "0",
  },
}));

const SimpleModal = ({
  openModal,
  setOpenModal,
  closeHandler,
  value,
  id,
  config = {},
  slug,
  ...props
}) => {
  const classes = useStyles();
  const { is_accepted_real_member, is_accepted_legal_member } = config;

  return (
    <div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.paper}>
          <Grid container direction="column" spacing={2}>
            <Grid item className={classes.top}>
              <Typography variant="body1" className={classes.title}>
                نوع عضویت خود را انتخاب کنید
              </Typography>
              <Button className={classes.closeIcon} onClick={closeHandler}>
                <AgapeIcon icon="close" size="1rem" />
              </Button>
            </Grid>
            <Grid item container className={classes.bot}>
              {!!is_accepted_real_member && (
                <Grid item xs={6} className={classes.btnBox}>
                  <Link href={`/membership/حقیقی/${slug}/${id}`}>
                    <a>
                      <Button className={classes.btn}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                        >
                          <Box style={{ width: "50px" }}>
                            <Image
                              src={realIma}
                              alt="realIma"
                              style={{ width: "100%" }}
                              layout="responsive"
                              width={100}
                              height={100}
                            />
                            <Typography
                              variant="caption"
                              className={classes.icontext}
                            >
                              حقیقی
                            </Typography>
                          </Box>
                          <Typography variant="caption">
                            عضویت به عنوان کاربر حقیقی
                          </Typography>
                        </Box>
                      </Button>
                    </a>
                  </Link>
                </Grid>
              )}
              {!!is_accepted_legal_member && (
                <Grid item xs={6} className={classes.btnBox}>
                  <Link href={`/membership/حقوقی/${id}`}>
                    <a>
                      <Button className={classes.btn}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                        >
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            flexDirection="column"
                            style={{ width: "50px" }}
                          >
                            <Image
                              src={orgIma}
                              alt="realIma"
                              style={{ width: "100%" }}
                              layout="responsive"
                              width={100}
                              height={100}
                            />
                            <Typography
                              variant="caption"
                              className={classes.icontext}
                            >
                              حقوقی
                            </Typography>
                          </Box>
                          <Typography variant="caption">
                            عضویت به عنوان سازمان یا کاربر حقوقی
                          </Typography>
                        </Box>
                      </Button>
                    </a>
                  </Link>
                </Grid>
              )}
            </Grid>
          </Grid>
          <SimpleModal />
        </div>
      </Modal>
    </div>
  );
};

export default SimpleModal;
